import { render, staticRenderFns } from "./ResizableWrapper.vue?vue&type=template&id=15935978&scoped=true&"
import script from "./ResizableWrapper.vue?vue&type=script&lang=ts&"
export * from "./ResizableWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableWrapper.vue?vue&type=style&index=0&id=15935978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15935978",
  null
  
)

export default component.exports